import { PresenceType } from '@momentum-ui/react-collaboration';

export interface ICallHistoryItemProps {
  id: string;
  name: string;
  phoneNumber: string;
  startTime: string;
  endTime: string;
  direction?: string | 'INCOMING' | 'OUTGOING';
  disposition?: string;
  isSelected?: boolean;
  callbackAddress?: string;
  missedCallText?: string;
  onPress?: (e: unknown) => void;
  itemIndex?: number;
  audioCallLabel?: string;
  videoCallLabel?: string;
  durationSeconds?: number;
  makeCall?: (address: string, isVideo?: boolean, label?: string) => void;
  callingSpecific?: string;
  isLocaleGerman?: boolean;
  dismissBagdeonClickRow?: () => void;
  lineNumber?: string;
  managedByName?: string;
  labelUnknown?: string;
  deleteSingleCallHistoryRecord?: (id: string, endTime: string) => void;
  callingContainerIds?: string[];
  isExpanded?: boolean;
  onExpandToggle?: (id: string) => void;
  expandedRowId?: string;
  presenceType?: PresenceType; // Presence type for Avatar component (Momentum UI PresenceType enum)
  presenceLabel?: string; // Presence label for accessibility
  /** Remote party Webex user ID for avatar retrieval */
  remotePartyId?: string;
}

export enum CallHistoryMoreOptionsMenuItemKeys {
  DELETE_SINGLE_RECORD = 'deleteSingleRecord',
} 
